var map = {
	"./033-bm.webp": 1289,
	"./033-cn.webp": 1290,
	"./033.webp": 1291,
	"./13-bm.webp": 1292,
	"./13-cn.webp": 1293,
	"./13.webp": 1294,
	"./3-bm.webp": 1295,
	"./3-cn.webp": 1296,
	"./3.webp": 1297,
	"./angpao-bm.webp": 1298,
	"./angpao-cn.webp": 1299,
	"./angpao.webp": 1300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1288;